<div class="invoice-detail-container">
  <div>
    <app-pdf-viewer [fileName]="fileName" [canDeleteQuoteAttachment]="canDeleteAttachment" [canDeleteOrderAttachment]="false" [attachments]="attachments" [objectId]="invoice.Id"
    [firstViewerDocumentSelector]="firstViewerDocumentSelector" [secondViewerDocumentSelector]="secondViewerDocumentSelector">
  </app-pdf-viewer>
  </div>
  <div class="bottom-bar">
    <app-invoice-detail-actions s [invoice]="invoice" [invoiceViewType]="invoiceViewType" [showGoBackDetailsButton]="true" [postActionCallBack]="postActionCallBack" [hidePDFViewerButton]="true"
      [hidePDFViewerButtonForPPR]="hidePDFViewerButtonForPPR" [canWaitInvoice]="CanWaitInvoice" [canProcessInvoice]="CanProcessInvoice">
    </app-invoice-detail-actions>
  </div>
</div>